var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.action)?_c('div',[(_vm.action.type === 'video')?_c('b-badge',{attrs:{"variant":"warning"}},[_c('i',{staticClass:"fa fa-file-movie-o"}),_vm._v(" "+_vm._s(_vm.action.title))]):_c('b-badge',{attrs:{"variant":"success"}},[_c('i',{staticClass:"fa fa-file"}),_vm._v(" "+_vm._s(_vm.action.title))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }